// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketOutcomeUnselected } from '../../actions/basket';
import { removeMultichoiceBetSelection } from '../../actions/mymatch';
import useMergeProps from '../../hooks/useMergeProps';
import { type BetBuilderItem } from '../../states/betbuilder';

import BasketCardMyMatchContentItem from './BasketCardMyMatchContentItem';
import selectCardMyMatchContentItemProps from './BasketCardMyMatchContentItem.selector';

type BasketCardMyMatchContentItemContainerProps = {
  className?: string;
  handleMyMatchEdit?: () => void;
  nbItems: number;
  prevItem?: BetBuilderItem;
} & BetBuilderItem;

const BasketCardMyMatchContentItemContainer = ({
  outcomeId,
  outcomeIds,
  betId,
  matchId,
  prevItem,
  ...ownProps
}: BasketCardMyMatchContentItemContainerProps) => {
  const dispatch = useDispatch();
  const selectorProps = useMemo(
    () => ({ outcomeId, outcomeIds, betId, matchId, prevItem }),
    [outcomeId, outcomeIds, betId, matchId, prevItem],
  );
  const selectedProps = useSelector((state) => selectCardMyMatchContentItemProps(state, selectorProps));

  const onOutcomeRemoval = useCallback(() => {
    if (matchId) {
      if (outcomeId) {
        dispatch(basketOutcomeUnselected({ oddId: outcomeId, matchId }));
      }

      if (Array.isArray(outcomeIds)) {
        dispatch(removeMultichoiceBetSelection({ betId, matchId }));
      }
    }
  }, [matchId, outcomeId, outcomeIds, dispatch, betId]);

  const otherProps = useMemo(
    () => ({
      onOutcomeRemoval,
    }),
    [onOutcomeRemoval],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <BasketCardMyMatchContentItem {...enhancedProps} />;
};

export default BasketCardMyMatchContentItemContainer;
